// Mobile design toolbar: bottom tool rows, Buy button, secondary-row toggle, and keyboard avoidance.

import { state } from './state.js'
import { ICONS } from './icons.js'

// Upload an image into the design via a native file picker → the SDK's
// addSDKImage. Replaces the dead `window.uploadImage` global the toolbar called.
// why → create review (mobile toolbar was wired to undefined globals).
function mobileUploadImage() {
  const input = document.createElement('input')
  input.type = 'file'
  input.accept = 'image/*'
  input.onchange = () => {
    const file = input.files && input.files[0]
    if (file) window.SDSManager?.addSDKImage?.(file)
  }
  input.click()
}

/**
 * Create design mode toolbar (replaces stage-header actions on mobile)
 */
export function createDesignToolbar() {
  const designMode = document.getElementById('mode-design')
  if (!designMode) return

  // Remove existing
  const existing = designMode.querySelector('.ws-mobile-toolbar')
  if (existing) existing.remove()

  const toolbar = document.createElement('div')
  toolbar.className = 'ws-mobile-toolbar'
  toolbar.id = 'wsMobileToolbar'

  // Primary row
  const primary = document.createElement('div')
  primary.className = 'ws-mobile-toolbar-primary'

  const tools = [
    { icon: ICONS.undo, action: () => window.SDSManager?.undo?.(), label: 'Undo' },
    { icon: ICONS.redo, action: () => window.SDSManager?.redo?.(), label: 'Redo' },
    { icon: ICONS.type, action: () => window.SDSManager?.addText?.(), label: 'Text' },
    { icon: ICONS.upload, action: () => mobileUploadImage(), label: 'Upload' },
    { icon: ICONS.save, action: () => window.SDSManager?.saveDesignToSDS?.(), label: 'Save' },
    { icon: ICONS.more, action: () => toggleSecondary(), label: 'More', id: 'wsMobileMoreBtn' },
  ]

  tools.forEach(({ icon, action, label, id }) => {
    const btn = document.createElement('button')
    btn.className = 'ws-mobile-tool-btn'
    if (id) btn.id = id
    btn.innerHTML = `${icon}<span class="ws-mobile-tool-label">${label}</span>`
    btn.onclick = action
    primary.appendChild(btn)
  })

  // (Manual "Publish to Shopify" button removed — publishing is automatic inside
  // Buy Now; the single user flow is Buy Now. Matches the desktop removal. why →
  // bao 2026-06-26/27 single-Buy-Now + create review.)

  // Buy Now button
  const buyBtn = document.createElement('button')
  buyBtn.className = 'ws-mobile-tool-btn ws-mobile-buy-btn'
  buyBtn.textContent = 'Buy'
  buyBtn.onclick = () => window.handleShareBuyClick?.(new Event('click'))
  primary.appendChild(buyBtn)

  toolbar.appendChild(primary)

  // Secondary row (hidden by default)
  const secondary = document.createElement('div')
  secondary.className = 'ws-mobile-toolbar-secondary'
  secondary.id = 'wsMobileToolbarSecondary'

  const secondaryTools = [
    { icon: ICONS.eye, action: () => window.SDSManager?.sendToTop?.(), label: 'Front' },
    { icon: ICONS.package, action: () => window.SDSManager?.sendToBottom?.(), label: 'Back' },
  ]

  secondaryTools.forEach(({ icon, action, label }) => {
    const btn = document.createElement('button')
    btn.className = 'ws-mobile-tool-btn'
    btn.innerHTML = icon
    btn.title = label
    btn.onclick = action
    secondary.appendChild(btn)
  })

  toolbar.appendChild(secondary)
  designMode.appendChild(toolbar)
}

/**
 * Toggle the secondary toolbar row (More button)
 */
export function toggleSecondary() {
  const secondary = document.getElementById('wsMobileToolbarSecondary')
  const moreBtn = document.getElementById('wsMobileMoreBtn')
  if (!secondary) return

  state.secondaryExpanded = !state.secondaryExpanded
  secondary.classList.toggle('expanded', state.secondaryExpanded)

  if (moreBtn) {
    moreBtn.style.transform = state.secondaryExpanded ? 'rotate(180deg)' : ''
  }
}

/**
 * Keep the toolbar above the on-screen keyboard via visualViewport resize tracking
 */
export function initKeyboardHandler() {
  if (!window.visualViewport) return

  window.visualViewport.addEventListener('resize', () => {
    const viewport = window.visualViewport
    const toolbar = document.getElementById('wsMobileToolbar')
    if (!toolbar) return

    const keyboardOpen = viewport.height < window.innerHeight * 0.75
    if (keyboardOpen) {
      toolbar.style.transform = `translateY(-${window.innerHeight - viewport.height - viewport.offsetTop}px)`
    } else {
      toolbar.style.transform = ''
    }
  })
}
